<app-modal-form>
  @if (component === 'tele-drawer-componente') {
    <app-modal-teledeteccion
      form
      (closeModal)="drawer.close()"
      (areaCreated)="onAreaCreated($event)"></app-modal-teledeteccion>
  }
  <mat-drawer-container id="content" [hasBackdrop]="true" plainContent>
    <mat-drawer
      id="TeledeteccionDrawer"
      #drawer
      mode="over"
      position="end"
      [opened]="opened_menu_panel"
      [scrollLeft]="true"
      (closed)="onCloseDrawer()">
      <!-- Panel derecho teledetección -->
      <div class="panel-content">
        <h3>Panel de Teledetección</h3>
        <!--Componentes específicos de teledetección -->
      </div>
    </mat-drawer>
    <mat-drawer-content>
      @if (fullRendered) {
        <div class="content">
          <div class="map-content">
            <!-- Componente del mapa de teledetección -->
            <ng-content></ng-content>
          </div>
        </div>
      }
    </mat-drawer-content>
  </mat-drawer-container>
</app-modal-form>
